import {type PlayerColor} from '../PlayerState.ts'

// TileEdgeDirection: https://prntscr.com/w5qsqr
export enum TileEdgeDirection {
    NorthWest = 0,
    West = 1,
    SouthWest = 2,
}

export enum TileEdgeType {
    Road = 1,
    Ship = 2,
}

export interface TileEdgeState {
    readonly x: number
    readonly y: number
    readonly z: TileEdgeDirection
    owner?: Exclude<PlayerColor, PlayerColor.None>
    type?: TileEdgeType
}
